import React from "react";
import { useRef } from "react";
import { InputGroup, Button, FormControl } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
export const SerachBox = (props) => {
  const refText = useRef(null);
  const keyupHandler = (e) => {
    if (e.keyCode === 13) {
      props.onButtonClick(refText);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "var(--bg-primary)",
        alignItems: "center",
        marginBottom: "0px",
      }}
    >
      <InputGroup>
        <FormControl
          type="text"
          ref={refText}
          aria-label="รหัส"
          name="text1"
          placeholder="ค้นหา ..."
          onKeyUp={keyupHandler}
        />
        <Button
          variant="danger"
          onClick={() => {
            props.onButtonClick(refText);
          }}
        >
          <AiOutlineSearch />
        </Button>
      </InputGroup>
    </div>
  );
};
